import { useEffect, useState } from "react";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import ImageModal from "../../../components/Tenant/ImageModal/ImageModal";
import { useFetchSalesUserMutation } from "../../../features/tenant/Siyaram/SiyaramApi";

const SiyaramSalesUsers = () => {
    const navigate = useNavigate();
    const [tableDataItems, setTableDataItems] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);
    const [showImage, setShowImage] = useState("")
    const [image, setImage] = useState("")
    const initialRequest = {
        limit: 10,
        offset: 0,
        mobile: "",
        emp_code: ""
    };
    const [request, setRequest] = useState(initialRequest);

    const clearFilters = () => {
        setRequest(initialRequest);
        handleBikajiOrdersList(initialRequest)
    };

    const [
        fetchSalesUser,
        {
            data: fetchAllSalesOrdersData,
            error: fetchAllSalesOrdersError,
            isLoading: fetchAllSalesOrdersisLoading,
        },
    ] = useFetchSalesUserMutation();

    const handleBikajiOrdersList = (orderRequest = request) => {
        fetchSalesUser({
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            token: sessionStorage.getItem("access_token"),
            body: orderRequest
        });
    };


    useEffect(() => {

        handleBikajiOrdersList();

    }, [limit, offset]);

    useEffect(() => {
        if (
            fetchAllSalesOrdersData &&
            fetchAllSalesOrdersData.body
        ) {
            toast.dismiss();
            toast.success(`${fetchAllSalesOrdersData.message}`, {
                id: "fetchAllSalesOrdersData",
            });
            console.log(
                "transactionsData  data",
                fetchAllSalesOrdersData
            );
            const arr = [...fetchAllSalesOrdersData.body.users];
            setTableDataItems(arr);

            setTotalRows(fetchAllSalesOrdersData &&
                fetchAllSalesOrdersData.body.total_users ? fetchAllSalesOrdersData.body.total_users : 0);

        }

        if (fetchAllSalesOrdersError) {
            console.log(
                "transactionsData error",
                fetchAllSalesOrdersError
            );
            toast.dismiss();
            toast.error(`${fetchAllSalesOrdersError.data.message}`, {
                id: "fetchAllSalesOrdersError",
            });
        }
    }, [
        fetchAllSalesOrdersData,
        fetchAllSalesOrdersError,
    ]);


    const columns = [
        {
            name: "S.No",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: "Name",
            selector: (row) => row.name,
        },
        {
            name: "Mobile  ",
            selector: (row) => row.mobile,
            width: "150px"
        },
        {
            name: "email",
            selector: (row) => row.email,
            width: "200px"
        },
        {
            name: "Employee Id",
            selector: (row) => row.employee_id,
        },
        {
            name: "",
            cell: (row) => (
                <div>
                    <button
                        onClick={() => navigate(`${row.employee_id}`)}
                        className="flex justify-center items-center rounded bg-success px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#14a44d] transition duration-150 ease-in-out hover:bg-success-600 focus:bg-success-600 active:bg-success-700"
                    >
                        View User
                    </button>
                </div>
            ),
            width: "250px",
        }
    ];
    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
        setCurrentPage(pageNumber);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setRequest((prevRequest) => ({
          ...prevRequest,
          limit: newPerPage,
          offset: 0,
        }));
        setLimit(newPerPage);
    setOffset(0);
        setCurrentPage(1);
        setPaginationResetToggle((prev) => !prev);

    };

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Siyaram Sales Users
                        <LinksComponent />
                    </div>

                    <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                        <div className="flex justify-between items-start">


                        </div>
                        <div className="flex  space-x-2 ">
                            <div className="w-52 ">
                                <div className="relative searchin">
                                    <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                        Mobile No
                                    </label>
                                    <input
                                        type="search"
                                        id="default-search"
                                        className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                                        placeholder="Mobile..."
                                        required
                                        value={request.mobile}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return { ...prevState, mobile: newValue };
                                            });
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="w-52 ">
                                <div className="relative searchin">
                                    <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                        Employee Id
                                    </label>
                                    <input
                                        type="search"
                                        id="default-search"
                                        className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                                        placeholder="Emp Code..."
                                        required
                                        value={request.emp_code}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return { ...prevState, emp_code: newValue };
                                            });
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="">
                                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                    &nbsp;
                                </label>

                                <div className="flex flex-row  gap-2 ">
                                    <div className="relative searchin">
                                        <button
                                            className="btn btn-outline-primary clear-both float-right  pdbtn_all"
                                            onClick={() => {
                                                handleBikajiOrdersList();

                                            }}
                                        >
                                            Search
                                        </button>
                                    </div>
                                    <div className="relative searchin">
                                        <button
                                            className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                                            onClick={() => {
                                                clearFilters();
                                            }}
                                        >
                                            Clear Filter
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="p-3">
                        {fetchAllSalesOrdersisLoading && <CircleLoaderComponent />}
                        <div className="p-3 w-full bg-white shadow rounded-lg">
                            <DataTableComponent
                                keyField={(row) => row.SNo}
                                columns={columns}
                                data={tableDataItems}
                                totalRows={
                                    fetchAllSalesOrdersData &&
                                    fetchAllSalesOrdersData?.body?.total_users
                                }
                                handlePerRowsChange={handlePerRowsChange}
                                handlePageChange={handlePageChange}
                                paginationDefaultPage={currentPage}
                                paginationResetDefaultPage={paginationResetToggle}
                            ></DataTableComponent>
                        </div>
                    </div>

                    {showImage && (
                        <ImageModal
                            show={showImage}
                            setShow={setShowImage}
                            size="md"
                            data={image}
                        >
                            <div className="w-[400px] h-[400px] overflow-hidden rounded-lg bg-gray-200">
                                <img
                                    src={image}
                                    alt="product-image"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                        </ImageModal>
                    )}

                </div>
            </div>
        </>
    );
};

export default SiyaramSalesUsers;
